import React, { Fragment, useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
import { FaRegCircle } from 'react-icons/fa';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdNotificationsNone, MdTipsAndUpdates, MdKeyboardArrowRight, MdCalendarMonth } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown } from 'react-icons/io';
import { FaHandshake, FaPlus } from 'react-icons/fa';
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch } from 'react-icons/ai'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { BiEdit } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu from '../../components/sidemenu';
import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { gray30, gray40, primary } from '../../utils/colors';
import Slider from '../../components/slider';
import AgendarCitaFamiliar from './agendar_familia_client';
import { Await, useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { AuthContext } from '../../context/auth_context';
import { GoGear } from 'react-icons/go';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';



export default function FamiliaClient() {
    const { user, logout } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const navigate = useNavigate()

    const [state, setState] = useState({
        tab: 0,
        show_cita_detail_id: null,
        family: [{
            img: 'https://source.boringavatars.com/beam/120/Stefan?colors=C0EFFF,f4a261',
            firstName: 'Laurie',
            lastName: 'Santos',
            relationType: 'Madre',
            email: 'example@dominio.com',
            phone: '12 23 45 56 78'
        }],
        member_active: null,
        add_new_member: false,
        edit_member: false,
        show_agendar_cita: false,
        show_modal_delete: false,

    })

    useState(() => {
        const init = async () => {
            const family = await Service('GET', 'Family');
            console.log(family)
            if (family.status === 200) {
                // family.data.map((item)=>{
                //     item.photo = 'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261'
                // })
                setState({ ...state, family: family.data, member_active: family.data.length > 0 ? family.data[0] : null })
            }
        };
        init();
        return () => { }
    }, [])

    const addFamilyMember = () => {
        state.family.push({
            photo: 'https://source.boringavatars.com/beam/120/Stefan?colors=' + Math.floor(Math.random() * 16777215).toString(16) + ',f4a261',
            firstName: 'Familiar',
            lastName: '',
            relationType: 'Agregar Relación',
            email: '',
            cellPhone: '',
            birthDate: ''
        })

        state.add_new_member = true;
        state.member_active = state.family[state.family.length - 1]
        state.edit_member = true;
        setState({ ...state })
    }
    const SaveNewMember = async () => {

        console.log(state.add_new_member)
        console.log(state.edit_member)

        let body = {

            relationship: state.member_active.relationType,
            name: state.member_active.firstName,
            lastName: state.member_active.lastName,
            email: state.member_active.email,
            cellPhone: state.member_active.cellPhone,
            photo: 'https://source.boringavatars.com/beam/120/Stefan?colors=' + Math.floor(Math.random() * 16777215).toString(16) + ',f4a261',
            birthDate: state.member_active.birthDate
        }

        if (state.edit_member && state.add_new_member === false) {


            let body = {
                relatedUser: state.member_active.id,
                relation: state.member_active.relationType,
                firstName: state.member_active.firstName,
                lastName: state.member_active.lastName,
                email: state.member_active.email,
                cellPhone: state.member_active.cellPhone,
                birthDate: state.member_active.birthDate
            }

            let _edit_family = await Service('PATCH', 'Family/update-user-from-family', body);
            if (_edit_family.status === 200) {
                console.log("actualizar")

                notify({ title: 'Familia', message: 'Listo! Se actualizo familiar', type: 'success' })
                setState({ ...state, edit_member: false })

            } else {

                notify({ title: 'Familia', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
            }

            return;

        }


        const add_family = await Service('POST', 'Family', body);

        if (add_family.status === 200) {

            console.log("Agregar")
            notify({ title: 'Familia', message: 'Listo! Se agrego un nuevo miembro de la Familia', type: 'success' })

        } else {

            notify({ title: 'Familia', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
        }
        setState({ ...state, edit_member: false, add_new_member: false })


    }
    const onDeleteMember = async () => {
        console.log(state.member_active)
        if (!state.member_active.id) {
            state.family.pop();
            state.edit_member = false;
            state.add_new_member = false;
            state.show_modal_delete = false;
            state.member_active = state.family[0];

            setState({ ...state })
            return;
        }
        let body = {
            userId: state.member_active.id
        }

        let _ondelete = await Service('DELETE', `Family/delete-user-from-family/`, body);
        console.log(_ondelete);
        if (_ondelete.status === 200) {

            notify({ title: 'Familia', message: 'Listo! Se elimino un miembro de la Familia', type: 'success' })

            state.family = state.family.filter((item) => item.id !== state.member_active.id)
            state.edit_member = false
            state.add_new_member = false;
            state.show_modal_delete = false;
            state.member_active = state.family[0];

            setState({ ...state })

        } else {

            notify({ title: 'Familia', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
        }



    }

    const arr = [1, 1, 1, 1, 1, 1, 1]


    return (
        <>
            <Renderif isTrue={state.show_agendar_cita}>
                <AgendarCitaFamiliar onSchedule={(cita) => { }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarCitaFamiliar>
            </Renderif>

            <Renderif isTrue={state.show_modal_delete === true}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow p-4'>
                        <div className='h5'>
                            Eliminar relación
                        </div>
                        <div className='f-14 text-gray my-2'>
                            ¿Estás seguro de que quieres eliminar esta relación?
                        </div>
                        <div className='bg-gray--txt-black p-2 my-4 bdr-10'>

                            <div className='card-notification flex-center-j-left m-2'>
                                <div className=''>
                                    <div className='avatar-profile'></div>
                                </div>
                                <div className='p-2'>
                                    <div className='bold f-14'>
                                        {state.member_active?.firstName} {state.member_active?.lastName}
                                    </div>
                                    <div className='f-12'>
                                        {state.member_active?.relationType}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='col'></div>

                            <div className='d-flex mb-'>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-tab--active-gray bv-icon bv-icon--mid`} onClick={() => {
                                        setState({ ...state, show_modal_delete: false })
                                    }}>
                                        Cancelar
                                    </div>
                                </div>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-cta--option-red bv-icon bv-icon--mid`} onClick={() => {
                                        onDeleteMember()
                                    }}>
                                        Eliminar relación
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </Renderif>
            <div className='container-fluid h-100 d-flex'>


                <SideMenu></SideMenu>

                <div className='container-fluid d-flex flex-column  h-100'>

                    <div className='d-flex flex-column flex-lg-row  bg-white p-2 p-sm-3 '>
                        <div className='d-flex align-items-center'>
                            <div className='input--light-curve'>
                                <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                <input placeholder='Busca Tips, Documentos, etc.'></input>
                            </div>
                        </div>
                        <div className='col'></div>

                        <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

                            <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                                <div className='pe-2 cita-button flex-center'>
                                    <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                        // setState({ ...state, show_agendar_cita: true })
                                        navigate('/client/crear-cita')
                                    }}>
                                        <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                        Agendar cita
                                    </div>
                                </div>
                                <div className='pe-2'>
                                    <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                        if (state.notifications_menu) {
                                            setState({ ...state, notifications_menu: false })
                                        } else {
                                            setState({ ...state, notifications_menu: true })
                                        }

                                    }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                                        <Renderif isTrue={state.notifications_menu}>
                                            <div className='float-menu'>
                                                <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                    Notificaciones
                                                </div>
                                                <div className='b-menu'>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className=''>
                                                            <div className='avatar-profile'></div>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Por el momento no cuenta con notificaciones
                                                        </div>
                                                    </div>
                                                    {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div> */}
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>
                                </div>

                                <div className='pe-2 me-4 agreements'>
                                    <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                        if (state.agreements_menu) {
                                            setState({ ...state, agreements_menu: false })
                                        } else {
                                            setState({ ...state, agreements_menu: true })
                                        }

                                    }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                                        <Renderif isTrue={state.agreements_menu}>
                                            <div className='float-menu'>
                                                <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                    Acuerdos pendientes
                                                </div>
                                                <div className='b-menu'>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className='flex-center ms-2'>
                                                            <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Por el momento no cuenta con acuerdos
                                                        </div>
                                                    </div>
                                                    {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Hacer ejercicio
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Leer
                                                            </div>
                                                        </div> */}
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>
                                </div>

                                <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                                    if (state.profile_menu) {
                                        setState({ ...state, profile_menu: false })
                                    } else {
                                        setState({ ...state, profile_menu: true })
                                    }

                                }}>
                                    <div className='avatar-profile  ms-lg-3'></div>
                                    <div className=''>
                                        <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                                    </div>

                                </div>
                                <Renderif isTrue={state.profile_menu}>
                                    <div className='float-menu-profile'>
                                        <div className='b-menu'>
                                            <div className='card-notification flex-center-j-left m-2'>
                                                <div className=''>
                                                    <div className='avatar-profile'></div>
                                                </div>
                                                <div className='p-2'>
                                                    <div className='bold f-14'>
                                                        {user?.firstName} {user?.lastName}
                                                    </div>
                                                    <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                                                        navigate('/client/profile')
                                                    }}>
                                                        Mi perfil
                                                        <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='b-menu'>
                                            <div className='card-notification d-flex separator-h-top cursor-pointer'>
                                                <div className='flex-center ms-2'>
                                                    <GoGear size={15} color={gray40}></GoGear>
                                                </div>
                                                <div className='flex-center f-12 p-2'>
                                                    Configuración
                                                </div>
                                            </div>
                                            <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                                                logout();
                                                navigate('/')
                                            }}>
                                                <div className='flex-center ms-2'>
                                                    <CgLogOut size={15} color={gray40} />
                                                </div>
                                                <div className='flex-center f-12 p-2'>
                                                    Cerrar sesión
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Renderif>
                            </div>



                        </div>
                    </div>
                    {/* MAQUETA VIEJA */}
                    {/* 
                    <div className='container-fluid'>
                        <div className='row'>

                            <div className='col-12 col-lg-7 col-xl-7 col-xxl-8 p-3'>

                                <div className='text-dark bold ps-2'>Información Familiar:</div>

                                <div className='d-flex mt-3 overflow-x-auto hide-scroll'>

                                    <div className='d-flex'>
                                        {state.family.map((item, i) => {

                                            return (
                                                <div key={i} className='d-flex flex-column  align-items-center'>

                                                    <div className={`avatar avatar--xl cursor-pointer mx-2 ${item.relationType === state.member_active?.relationType ? 'avatar--active' : ''}`} style={{ 'backgroundImage': 'url(' + item.photo + ')' }} onClick={() => {
                                                        state.member_active = item;
                                                        state.edit_member = false;
                                                        setState({ ...state })
                                                    }}></div>




                                                    <div className='text-gray f-12 text-center no-wrap px-1'>{item.relationType === state.member_active?.relationType ? state.member_active.relationType : item.relationType}</div>
                                                </div>
                                            )

                                        })}



                                        <div className='d-flex flex-column  align-items-center'>
                                            <div className='bv-icon bv-icon--xl bg-gray-00 r-100 cursor-pointer' onClick={() => {
                                                addFamilyMember()
                                            }}>
                                                <FaPlus size={30} color={primary}></FaPlus>
                                            </div>
                                            <div className='text-gray f-12 text-center no-wrap'>Agregar Familiar</div>
                                        </div>
                                    </div>


                                </div>
                                <Renderif isTrue={state.member_active !== null}>


                                    <div className='bv-card mt-4 p-3'>
                                        <div className='d-flex '>

                                            <div className='d-flex'>
                                                <div className='avatar avatar--mid' style={{ 'backgroundImage': 'url(' + state.member_active?.photo + ')' }}></div>
                                                <div className='d-flex flex-column ms-2'>
                                                    <div className='text-dark f-16 bold'>{state.member_active?.firstName + ' ' + state.member_active?.lastName}</div>
                                                    <div className='text-gray f-14'>{state.member_active?.relationType}</div>
                                                </div>
                                            </div>
                                            <div className='col'></div>

                                            <div className='bv-icon bv-icon--big bg-gray-00 r-8 cursor-pointer' onClick={() => {
                                                setState({ ...state, edit_member: true })
                                            }}>
                                                <BiEdit size={26} color={primary}></BiEdit>
                                            </div>

                                        </div>

                                        <div className='mt-4'>
                                            <div className='d-flex'>

                                                <div className='col d-flex flex-column r-8 me-1 py-2 px-2 shadow'>
                                                    <div className='text-dark f-14 bold'>Relación Familiar:</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <div className='text-gray f-14'>{state.member_active?.relationType}</div>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' defaultValue={state.member_active?.relationType} onChange={(evt) => {
                                                            state.member_active.relationType = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>

                                                </div>

                                            </div>

                                            <div className='my-2'></div>
                                            <div className='d-flex'>

                                                <div className='col d-flex flex-column r-8 me-1 py-2 px-2 shadow'>
                                                    <div className='text-dark f-14 bold'>Nombre (s):</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <div className='text-gray f-14'>{state.member_active?.firstName}</div>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' defaultValue={state.member_active?.firstName} onChange={(evt) => {
                                                            state.member_active.firstName = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>
                                                </div>

                                                <div className='col d-flex flex-column r-8 ms-1 py-2 px-2 shadow '>
                                                    <div className='text-dark f-14 bold'>Apellido(s):</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <div className='text-gray f-14'>{state.member_active?.lastName}</div>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' defaultValue={state.member_active?.lastName} onChange={(evt) => {
                                                            state.member_active.lastName = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>
                                                </div>

                                            </div>

                                            <div className='my-2'></div>

                                            <div className='d-flex'>

                                                <div className='col d-flex flex-column r-8 me-1 py-2 px-2 shadow '>
                                                    <div className='text-dark f-14 bold'>Correo Electrónico:</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <div className='text-gray f-14'>{state.member_active?.email}</div>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' defaultValue={state.member_active?.email} onChange={(evt) => {
                                                            state.member_active.email = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>
                                                </div>

                                                <div className='col d-flex flex-column  r-8 ms-1 py-2 px-2 shadow '>
                                                    <div className='text-dark f-14 bold'>Teléfono a 10 digitos:</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <div className='text-gray f-14'>{state.member_active?.cellPhone}</div>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' defaultValue={state.member_active?.cellPhone} onChange={(evt) => {
                                                            state.member_active.cellPhone = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>
                                                </div>
                                            </div>

                                            <div className='my-2'></div>

                                            <div className='d-flex'>

                                                <div className='col d-flex flex-column r-8 me-1 py-2 px-2 shadow '>
                                                    <div className='text-dark f-14 bold'>Fecha de nacimiento:</div>
                                                    <Renderif isTrue={!state.edit_member}>
                                                        <input type='date' className='text-gray f-14' Value={state.member_active?.birthDate} readOnly style={{ border: 'none', outline: 'none' }}></input>
                                                    </Renderif>
                                                    <Renderif isTrue={state.edit_member}>
                                                        <input className='input--light' type='date' max="9999-12-31" defaultValue={state.member_active?.birthDate} onChange={(evt) => {
                                                            state.member_active.birthDate = evt.currentTarget.value;
                                                            setState({ ...state })
                                                        }}></input>
                                                    </Renderif>
                                                </div>

                                                <div className='col d-flex flex-column  r-8 ms-1 py-2 px-2 shadow opacity-0 '>

                                                </div>
                                            </div>

                                        </div>

                                        <Renderif isTrue={state.edit_member}>
                                            <div className='d-flex mt-2 mx-1'>
                                                <div className='col'></div>
                                                <div className='text-gray f-12 text-decoration-underline cursor-pointer text-red' onClick={() => {
                                                    onDeleteMember()
                                                }}>Eliminar Familiar</div>
                                            </div>
                                            <div className='mt-3'>

                                                <div className='bv-pill bv-pill--green cursor-pointer me-3' onClick={() => {
                                                    SaveNewMember()
                                                }}>Guardar</div>


                                                <div className='bv-pill bv-pill--red cursor-pointer' onClick={() => {

                                                    if (state.add_new_member === true) {
                                                        state.family.pop();
                                                    }

                                                    state.edit_member = false
                                                    state.add_new_member = false;
                                                    setState({ ...state })


                                                }}>Cancelar</div>




                                            </div>

                                        </Renderif>




                                    </div>

                                </Renderif>


                            </div>


                            <div className='col-12 col-lg-5 col-xl-5 col-xxl-4 p-3'>
                                <div className='bv-card bg-gray-00 p-4'>
                                    <div className='text-dark bold px-1'>Tu siguiente cita:</div>

                                    <div className='bg-white p-3 mt-3 r-8'>

                                        <div className='d-flex '>
                                            <div className='avatar avatar--xl'></div>
                                            <div className='col'></div>
                                            <div className='d-flex flex-column align-items-end justify-content-end'>
                                                <div className='text-dark f-16 bold opacity-0'>Dr. Raymundo Marqueda</div>
                                                <div className='text-primary f-14 opacity-0'>Psicologo Conductual</div>
                                                <div className='bv-pill bv-pill--primary mt-3 opacity-0'>Video llamada</div>
                                            </div>
                                        </div>

                                        <div className='d-flex justify-content-between mt-3 px-3 py-2 r-25 bg-gray-00'>
                                            <div className='f-12 bold text-gray opacity-0'>13 Nov. 2023</div>
                                            <div className='f-12 bold text-gray opacity-0'>5:00 pm</div>
                                            <div className='f-12 bold text-gray opacity-0'>Sesión #<span className='bold'>6</span></div>
                                        </div>



                                    </div>
                                    <div className='bg-white p-3 mt-3 r-8'>

                                        <div className='d-flex '>

                                            <div className='col d-flex flex-column align-items-center'>

                                                <div className='position-relative'>
                                                    <img width={200} className='img-fluid' src='/assets/elipse4.svg'></img>

                                                    <div className='position-absolute absolute-center absolute-center--0'>
                                                        <div className='text-dark f-22 bold'>0/5</div>
                                                    </div>

                                                </div>


                                                <div className='text-dark f-14 mb-3'> Paquete Pro Familiar</div>
                                                <div className='bv-pill bv-pill--gray'>Ver Sesiones Anteriores</div>
                                            </div>

                                            <div className='col'></div>

                                            <div className='col d-flex flex-column justify-content-center '>


                                                <div className='d-flex align-items-center'>
                                                    <div className='dot dot--primary mx-2'></div>
                                                    <div className='text-dark f-14 line-0'>Sesiones</div>
                                                </div>
                                                <div className='d-flex align-items-center'>
                                                    <div className='dot dot--primary mx-2 opacity-0'></div>
                                                    <div className='text-dark f-14 line-0'>Complementadas</div>
                                                </div>

                                                <div className='my-2'></div>

                                                <div className='d-flex align-items-center'>
                                                    <div className='dot dot--green mx-2'></div>
                                                    <div className='text-dark f-14 line-0'>Acuerdos</div>
                                                </div>
                                                <div className='d-flex align-items-center'>
                                                    <div className='dot dot--green mx-2 opacity-0'></div>
                                                    <div className='text-dark f-14 line-0'>Complementadas</div>
                                                </div>





                                            </div>
                                        </div>





                                    </div>
                                    <div className='d-flex  p-3 mt-3 r-8'>

                                        <div className='d-flex flex-column align-items-center col bg-primary r-8 me-2 p-3 cursor-pointer' onClick={() => {
                                            navigate('/client/tips')
                                        }}>
                                            <img className='w-100' src='/assets/Tips.svg'></img>
                                            <div className='text-white f-14 text-center bold'>Expolora Tips</div>
                                        </div>
                                        <div className='d-flex flex-column align-items-center col bg-green r-8 ms-2 p-3 cursor-pointer' onClick={() => {
                                            navigate('/client/documentos')
                                        }}>
                                            <img className='w-100' src='/assets/Documentos.svg'></img>
                                            <div className='text-white f-14 text-center bold'>Expolora Documentos</div>
                                        </div>


                                    </div>

                                </div>
                            </div>

                        </div>
                    </div> */}

                    {/* MAQUETA VIEJA */}

                    {/* NUEVA MAQUETA */}
                    <div className='row'>
                        <div className='col-1 col-sm-2'>

                        </div>
                        <div className='col-10 col-sm-8'>
                            <div className='h4 txt-center'>
                                Información familiar
                            </div>
                            <div className='flex-center mt-3 overflow-x-auto hide-scroll bold'>

                                <div className='d-flex'>
                                    {state.family.map((item, i) => {

                                        return (
                                            <div key={i} className='d-flex flex-column  align-items-center'>

                                                <div className={`avatar avatar--xl cursor-pointer mx-2 ${item.relationType === state.member_active?.relationType ? 'avatar--active' : ''}`} style={{ 'backgroundImage': 'url(' + item.photo + ')' }} onClick={() => {
                                                    state.member_active = item;
                                                    state.edit_member = false;
                                                    setState({ ...state })
                                                }}></div>




                                                <div className='text-gray f-12 text-center no-wrap px-1'>{item.firstName === state.member_active?.firstName ? state.member_active.firstName : item.firstName}</div>
                                            </div>
                                        )

                                    })}



                                    <div className='d-flex flex-column  align-items-center'>
                                        <div className='bv-icon bv-icon--xl bg-gray-00 r-100 cursor-pointer' onClick={() => {
                                            addFamilyMember()
                                        }}>
                                            <FaPlus size={30} color={primary}></FaPlus>
                                        </div>
                                        <div className='text-gray f-12 text-center no-wrap'>Nuevo perfil</div>
                                    </div>
                                </div>
                            </div>

                            <Renderif isTrue={state.member_active !== null}>


                                <div className='bv-card mt-4 p-3'>
                                    <div className='d-flex'>

                                        <div className='h4'>
                                            <Renderif isTrue={state.member_active?.relationType === "Agregar Relación"}>
                                                Agregar familiar
                                            </Renderif>
                                        </div>

                                    </div>

                                    <div className='mt-1'>
                                        <div className='my-2'></div>
                                        <div className='d-sm-flex'>

                                            <div className='col d-flex flex-column r-8 me-sm-1 py-2 px-2 shadow'>
                                                <div className='text-dark f-14 bold'>Nombre</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <div className='text-gray f-14'>{state.member_active?.firstName}</div>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' defaultValue={state.member_active?.firstName} onChange={(evt) => {
                                                        state.member_active.firstName = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>
                                            </div>

                                            <div className='col d-flex flex-column r-8 ms-sm-1 py-2 px-2 shadow '>
                                                <div className='text-dark f-14 bold'>Apellido</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <div className='text-gray f-14'>{state.member_active?.lastName}</div>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' defaultValue={state.member_active?.lastName} onChange={(evt) => {
                                                        state.member_active.lastName = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>
                                            </div>

                                        </div>

                                        <div className='my-2'></div>

                                        <div className='d-sm-flex'>

                                            <div className='col d-flex flex-column r-8 me-sm-1 py-2 px-2 shadow '>
                                                <div className='text-dark f-14 bold'>Fecha de nacimiento</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <input type='date' className='text-gray f-14' Value={state.member_active?.birthDate} readOnly style={{ border: 'none', outline: 'none' }}></input>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' type='date' max="9999-12-31" defaultValue={state.member_active?.birthDate} onChange={(evt) => {
                                                        state.member_active.birthDate = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>
                                            </div>

                                            <div className='col d-flex flex-column r-8 ms-sm-1 py-2 px-2 shadow'>
                                                <div className='text-dark f-14 bold'>Relación</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <div className='text-gray f-14'>{state.member_active?.relationType}</div>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' defaultValue={state.member_active?.relationType} onChange={(evt) => {
                                                        state.member_active.relationType = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>

                                            </div>
                                        </div>

                                        <div className='my-2'></div>

                                        <div className='d-sm-flex'>



                                            <div className='col d-flex flex-column r-8 me-sm-1 py-2 px-2 shadow '>
                                                <div className='text-dark f-14 bold'>Correo electrónico:</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <div className='text-gray f-14'>{state.member_active?.email}</div>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' defaultValue={state.member_active?.email} onChange={(evt) => {
                                                        state.member_active.email = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>
                                            </div>

                                            <div className='col d-flex flex-column  r-8 ms-sm-1 py-2 px-2 shadow '>
                                                <div className='text-dark f-14 bold'>Teléfono</div>
                                                <Renderif isTrue={!state.edit_member}>
                                                    <div className='text-gray f-14'>{state.member_active?.cellPhone}</div>
                                                </Renderif>
                                                <Renderif isTrue={state.edit_member}>
                                                    <input className='input--light' defaultValue={state.member_active?.cellPhone} onChange={(evt) => {
                                                        state.member_active.cellPhone = evt.currentTarget.value;
                                                        setState({ ...state })
                                                    }}></input>
                                                </Renderif>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className='d-flex mb-4'>
                                    <div className='col'>

                                    </div>
                                    <div className='mt-3 d-flex b-100 scrollmenu'>

                                        <div className='pe-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option-transparent bv-icon bv-icon--mid bv-pill--red txt-white`} onClick={() => {
                                                setState({ ...state, show_modal_delete: true })
                                            }}>
                                                Eliminar relación
                                            </div>
                                        </div>
                                        <Renderif isTrue={state.edit_member}>
                                            <div className='pe-2 flex-center'>
                                                <div className={`bv-cta-curve bv-cta--option-transparent bv-icon bv-icon--mid bv-tab--active-gray`} onClick={() => {
                                                    SaveNewMember()

                                                }}>
                                                    Guardar cambios
                                                </div>
                                            </div>
                                            <div className='pe-2 flex-center'>
                                                <div className={`bv-cta-curve bv-cta--option-transparent bv-icon bv-icon--mid bv-tab--active-gray`} onClick={() => {
                                                    if (!state.member_active.id) {
                                                        state.family.pop();
                                                        state.edit_member = false;
                                                        state.add_new_member = false;
                                                        state.show_modal_delete = false;
                                                        state.member_active = state.family[0];

                                                        setState({ ...state })
                                                        return;
                                                    } else {
                                                        setState({ ...state, edit_member: false })
                                                    }

                                                }}>
                                                    Cancelar
                                                </div>
                                            </div>
                                        </Renderif>

                                        <Renderif isTrue={state.edit_member === false}>
                                            <div className='pe-2 flex-center'>
                                                <div className={`bv-cta-curve bv-cta--option-transparent bv-icon bv-icon--mid bv-tab--active-gray`} onClick={() => {
                                                    setState({ ...state, edit_member: true })
                                                }}>
                                                    Editar
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>
                                </div>

                            </Renderif>
                        </div>
                        <div className='col-1 col-sm-2'>

                        </div>
                    </div>
                    {/* NUEVA MAQUETA */}


                </div>
            </div>
        </>
    )
}

const CitaDetail = ({ ...props }) => {
    const [state, setState] = useState({
        tab: 0
    })
    const arr = [1, 1, 1, 1, 1, 1, 1]
    return (
        <div className='d-grid'>
            <div className='d-flex p-1'>
                <div className='col'></div>
                <div className='py-2 d-flex'>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 0 }) }}>
                        Acuerdos 2/10
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 1 }) }}>
                        <div className='bv-icon me-1'><MdTipsAndUpdates></MdTipsAndUpdates></div>
                        <div>Tips </div>
                        <span className='text-blue f-12 bold ms-2'>5</span>
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 2 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 2 }) }}>
                        <div className='bv-icon me-1'><AiFillFolder></AiFillFolder></div>
                        <div>Documentos</div>
                        <span className='text-blue f-12 bold ms-2'>5</span>
                    </div>
                </div>
            </div>


            <Renderif isTrue={state.tab === 0}>
                <div className=' d-flex '>
                    <div className='col'>

                        <div className='p-2 d-flex bg-white'>
                            <CheckBox text={'Tomar 1.5 Lts de agua diariamente'} />
                        </div>

                        <div className='p-2 d-flex'>

                            <CheckBox text={'Mantener diario de pensamientos y subir .pdf de la semana'} />
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Subir Archivo</div>

                        </div>
                        <div className='p-2 d-flex bg-white'>
                            <CheckBox text={'Subir test cognitivos'} />
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Subir Archivo</div>
                        </div>

                        <div className='p-2 d-flex align-items-center'>
                            <CheckBox text={'Subir dibujo de casa'} />
                            <div className='col'></div>
                            <div className='f-12 text-gray pe-2'>casa_photo.jpg</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Ver o Editar</div>
                        </div>


                        <div className='p-2 bg-white' >
                            <CheckBox text={'Camianar al menos 15 minutos al dia'} />
                        </div>

                    </div>

                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 1}>
                <div className='overflow-auto no-wrap px-2 pb-4 pt-1 w-100 hide-scroll'>

                    {arr.map((item, i) => {
                        return (
                            <div className='w-25-50-100 d-inline-block pe-2' key={i}>
                                <div className='bv-card w-100'>
                                    <div className='bv-card-img'></div>
                                    <div className='f-12 py-1'>Toma 3 litros de agua al dia</div>
                                    <div className='col'></div>
                                    <div className='d-flex align-items-end'>
                                        <div className='f-12 bold text-blue p-1'>Tip #1</div>
                                        <div className='col'></div>
                                        <Renderif isTrue={i === 0}>
                                            <div className='text-white bg-purple bold f-12 px-3 py-1 my-1'>¡Nuevo!</div>
                                        </Renderif>
                                        <Renderif isTrue={i === 2}>
                                            <div className='text-white bg-orange bold f-12 px-3 py-1 my-1'>¡Asignado!</div>
                                        </Renderif>

                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 2}>
                <div className=' d-flex '>
                    <div className='col'>


                        <div className='p-2 d-flex align-items-center bg-white'>

                            <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                            <div className='f-12 text-gray ps-2'>casa_photo.jpg</div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Ver o Editar</div>
                        </div>

                        <div className='p-2 d-flex align-items-center'>
                            <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                            <div className='f-12 text-gray ps-2'>perfil.pdf</div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Ver o Editar</div>
                        </div>

                        <div className='p-2 d-flex align-items-center bg-white'>

                            <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                            <div className='f-12 text-gray ps-2'>metas_2023.pdf</div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--primary cursor-pointer'>Ver o Editar</div>
                        </div>





                    </div>

                </div>
            </Renderif>

        </div>
    )
}

const CitaItem = ({ ...props }) => {
    return (
        <div className='b-bottom align-items-start p-1 highlight-hover--light'>

            <div className='d-flex'>
                <div>
                    <div className='text-gray f-12 bold'>Dr. Ray Marqueda Mejia</div>
                    <div className='text-gray f-10'>Variatra</div>
                </div>
                <div className='col'></div>
                <div className='f-10 bold text-gray'>
                    #AT318790 <MdKeyboardArrowRight color='gray' size={16}></MdKeyboardArrowRight>
                </div>
            </div>
            <div className='d-flex mt-2'>
                <div className='d-flex justify-content-start'>
                    <div className='text-gray f-10'>Jul 13 2023, </div>
                </div>
                <div className='d-flex justify-content-center ps-1'>
                    <div className='text-gray f-10'>5:25 PM</div>
                </div>



                <div className='d-flex justify-content-end ps-2'>
                    <div className='text-gray f-10'>Sesión: <span className='bold text-black'>5</span></div>
                </div>
            </div>



        </div>
    )
}